/* eslint-disable max-lines */
import { type TranslationDataObj } from './type';

export const data: TranslationDataObj = {
  'app.brand-context.index': {
    title: {
      en: 'Brand context',
      fr: 'Brand context',
    },
    description: {
      en: 'These details help the AI create content that aligns with your brand.',
      fr: "Ces détails aident l'IA à créer du contenu qui correspond à votre marque.",
    },
    saveChanges: {
      en: 'Save',
      fr: 'Enregistrer',
    },
    general: {
      en: 'General',
      fr: 'Général',
    },
    personas: {
      en: 'Personas',
      fr: 'Personas',
    },
    excerpts: {
      en: 'Voice examples',
      fr: 'Exemples de contenus',
    },
    content: {
      en: 'Content',
      fr: 'Contenu',
    },
    writingStyle: {
      en: 'Writing style',
      fr: `Style d'écriture`,
    },
    keywordsBlacklisted: {
      en: 'Keywords blacklisted',
      fr: 'Termes à exclure',
    },
    brandNotFound: {
      en: 'Brand not found',
      fr: 'Marque non trouvée',
    },
    brandUpdated: {
      en: 'Brand context saved',
      fr: 'Brand context enregistré',
    },
    brandInvalid: {
      en: 'Brand is invalid',
      fr: 'Marque invalide',
    },
    brandInvalidDescription: {
      en: 'Please check your brand fields',
      fr: 'Veuillez vérifier les champs de votre marque',
    },
    brandLoading: {
      en: 'Brand loading',
      fr: 'Marque en cours de chargement',
    },
    unsavedChanges: {
      en: "Seems you haven't saved your changes.",
      fr: "Il semble que vous n'avez pas enregistré vos modifications.",
    },
    unsavedChangesDescription: {
      en: 'Would you like to save your changes?',
      fr: 'Voulez-vous enregistrer vos modifications ?',
    },
  },
  'app.brand-context.-tab-company': {
    targeting: {
      en: 'Targeting',
      fr: 'Ciblage',
    },
    brandDetails: {
      en: 'Brand details',
      fr: 'À propos de la marque',
    },
    brandDetailsDesc: {
      en: 'Fill in the details below to provide additional context about your brand',
      fr: 'Renseignez les détails ci-dessous pour fournir un contexte supplémentaire sur votre marque',
    },
    targetingDescription: {
      en: 'This setting will be used as the default in the SERP analysis but can be customized for each piece of content created using Blym.',
      fr: 'Cette configuration sera utilisée par défaut dans l’analyse de la SERP, mais peut être personnalisée pour chaque article créé à l’aide de Blym.',
    },
    basicInformation: {
      en: 'Brand details',
      fr: 'À propos de la marque',
    },
    theCompany: {
      en: 'The company',
      fr: 'L’entreprise',
    },
    companyName: {
      en: 'Name',
      fr: 'Nom',
    },
    companyNamePlaceholder: {
      en: 'e.g Nooma',
      fr: 'e.g Nooma',
    },
    companyWebsite: {
      en: 'Website',
      fr: 'Site web',
    },
    companyWebsitePlaceholder: {
      en: 'e.g https://www.nooma.com',
      fr: 'e.g https://www.nooma.com',
    },
    companyIndustry: {
      en: 'Industry',
      fr: 'Secteur',
    },
    selectAnIndustry: {
      en: 'Select an industry',
      fr: 'Sélectionner un secteur',
    },
    companyIndistrySeller: {
      en: 'I sell my own products',
      fr: 'Je vends mes propres produits',
    },
    companyTypeOfBusiness: {
      en: 'Type of business',
      fr: "Type d'entreprise",
    },
    companyTypeOfBusinessDescription: {
      en: 'Select one',
      fr: 'Sélectionnez une entreprise',
    },
    brandAttributes: {
      en: 'Brand attributes',
      fr: 'Attributs de la marque',
    },
    b2b: {
      en: 'B2B',
      fr: 'B2B',
    },
    b2c: {
      en: 'B2C',
      fr: 'B2C',
    },
    na: {
      en: 'N/A',
      fr: 'N/A',
    },
    selectOneOrMore: {
      en: 'Select one or more',
      fr: 'Sélectionnez une ou plusieurs',
    },
    brandValue: {
      en: 'Brand value (optional)',
      fr: 'Valeur de la marque (optionnel)',
    },
    companyIndistrySellerDescription: {
      en: 'You create/manufacture the products you sell',
      fr: 'Vous créez/fabriquez les produits que vous vendez',
    },
    companyIndistryReseller: {
      en: 'I am a reseller',
      fr: 'Je suis un revendeur',
    },
    companyIndistryResellerDescription: {
      en: 'I sell products made by others',
      fr: "Je vend des produits d'autres",
    },
    companyIndistryService: {
      en: 'I don’t sell products',
      fr: 'Je ne vends pas de produits',
    },
    companyIndistryServiceDescription: {
      en: 'I offer services, SaaS, or content',
      fr: 'Je propose des services, des logiciels ou du contenu',
    },
    companyActivity: {
      en: 'Describe your activity',
      fr: 'Décrivez votre activité',
    },
    companyActivityPlaceholder: {
      en: 'E.g., Online store specializing in natural home and wellness products.',
      fr: 'ex: Boutique en ligne spécialisée dans les produits naturels pour la maison et le bien-être.',
    },
    companyExtraInfo: {
      en: 'Add extra information (optional)',
      fr: 'Informations supplémentaires (optionnel)',
    },
    companyExtraInfoPlaceholder: {
      en: 'Enrich your AI writing with more information, include texts, or websites.',
      fr: "Enrichissez votre écriture IA avec plus d'informations, incluez du texte ou des sites web.",
    },
    productCategory: {
      en: 'What do you sell ?',
      fr: 'Que vendez-vous ?',
    },
    ecommerces: {
      en: 'E-commerce',
      fr: 'E-commerce',
    },
    saas: {
      en: 'SaaS',
      fr: 'SaaS',
    },
    services: {
      en: 'Services',
      fr: 'Services',
    },
    manufacturing: {
      en: 'Manufacturing',
      fr: 'Fabrication',
    },
    retail: {
      en: 'Retail & Local businesses',
      fr: 'Vente au détail et entreprises locales',
    },
    other: {
      en: 'Other: enter your product category',
      fr: 'Autre: entrez votre catégorie de produit',
    },
    country: {
      en: 'Default country',
      fr: 'Pays par défaut',
    },
    selectACountry: {
      en: 'Select a country',
      fr: 'Sélectionner un pays',
    },
    language: {
      en: 'Default language',
      fr: 'Langue par défaut',
    },
    selectALanguage: {
      en: 'Select a language',
      fr: 'Sélectionner une langue',
    },
  },
  'app.brand-context.-tab-persona': {
    addPersona: {
      en: 'Add persona',
      fr: 'Ajouter un persona',
    },
    demographics: {
      en: 'Demographics',
      fr: 'Demographie',
    },
    description: {
      en: 'Description',
      fr: 'Description',
    },
    descriptionPlaceholder: {
      en: 'E.g., Young urban professional, concerned about their well-being and attracted by responsible brands.',
      fr: 'ex: Jeune professionnel urbain, soucieux de son bien-être et attiré par les marques responsables.',
    },
    insights: {
      en: 'Insights',
      fr: 'Informations stratégiques',
    },
    selectAGender: {
      en: 'Select a gender',
      fr: 'Sélectionner un genre',
    },
    serpInformation: {
      en: 'This setting will be used as the default in the SERP analysis but can be customized for each piece of content created using Blym.',
      fr: 'Cette configuration sera utilisée par défaut dans l’analyse de la SERP, mais peut être personnalisée pour chaque article créé à l’aide de Blym.',
    },
    interest: {
      en: 'Interest',
      fr: 'Objectif',
    },
    interestPlaceholder: {
      en: 'E.g.: Save time in daily life while making more sustainable choices.',
      fr: 'ex: Gagner du temps dans la vie quotidienne tout en faisant des choix plus durables.',
    },
    painPoints: {
      en: 'Pain points',
      fr: 'Problèmes rencontrés',
    },
    painPointsPlaceholder: {
      en: 'E.g.: Lack of time, high prices, difficulty trusting brands.',
      fr: 'ex: Manque de temps, prix élevé, difficulté à faire confiance aux marques.',
    },
    age: {
      en: 'Age',
      fr: 'Âge',
    },
    gender: {
      en: 'Gender',
      fr: 'Genre',
    },
    selectAnAge: {
      en: 'Select an audience age',
      fr: 'Sélectionner un âge de public',
    },
    '18-24': {
      en: 'Young adults, students, early career professionals.',
      fr: 'Jeunes adultes, étudiants, professionnels au début de leur carrière.',
    },
    '25-34': {
      en: 'Working professionals, emerging buyers.',
      fr: 'Professionnels au travail, futurs acheteurs.',
    },
    '35-44': {
      en: 'Mid-career professionals, parents, decision-makers.',
      fr: 'Professionnels au milieu de leur carrière, parents, décideurs.',
    },
    '45-54': {
      en: 'Senior professionals, high-income earners, experienced buyers.',
      fr: 'Professionnels seniors, hauts revenus, acheteurs expérimentés.',
    },
    '55-64': {
      en: 'Near-retirement, experienced consumers.',
      fr: 'Près de la retraite, consommateurs expérimentés.',
    },
    '65+': {
      en: 'Retirees, older demographics.',
      fr: 'Retraités, plus âgés.',
    },
    all: {
      en: 'Any gender',
      fr: 'Tous les genres',
    },
    male: {
      en: 'Male',
      fr: 'Homme',
    },
    female: {
      en: 'Female',
      fr: 'Femme',
    },
    setPrimaryPersona: {
      en: 'Set as primary persona',
      fr: 'Définir comme persona principale',
    },
    editName: {
      en: 'Edit name',
      fr: 'Modifier le nom',
    },
    delete: {
      en: 'Delete persona',
      fr: 'Supprimer le persona',
    },
    newPersonaName: {
      en: 'New persona',
      fr: 'Nouveau persona',
    },
    enterAName: {
      en: 'Enter a name',
      fr: 'Entrez un nom',
    },
    yourPersonaHere: {
      en: 'Your personas will appear here',
      fr: 'Vos personas apparaîtront ici',
    },
    deletePersona: {
      en: 'Delete persona',
      fr: 'Supprimer le persona',
    },
  },
  'app.brand-context.-tab-excerpt': {
    excerpt: {
      en: 'Voice example',
      fr: 'Exemple de contenu',
    },
    excerptsHelpText: {
      en: 'Provide example content to guide the AI. Use short, real excerpts from your website or product pages to help it learn your brand’s voice and style more accurately.',
      fr: "Fournissez un exemple de contenu pour guider l'IA. Utilisez des exemples courts et réels de votre site web ou de vos pages de produit pour aider l'IA à apprendre votre voix et votre style de marque plus précisément.",
    },
    learnMore: {
      en: 'Learn more',
      fr: 'En savoir plus',
    },
    addExcerpt: {
      en: 'Add voice example',
      fr: 'Ajouter un exemple de contenu',
    },
    descriptionPlaceHolder: {
      en: 'Add a text excerpt reflecting how your brand expresses itself (article, email, post, etc.)…',
      fr: 'Ajoutez un extrait de texte reflétant la manière dont votre marque s’exprime (article, email, post, etc.)…',
    },
    yourExcerptHere: {
      en: 'Your examples will appear here',
      fr: 'Vos exemples apparaîtront ici',
    },
    editLabel: {
      en: 'Edit label',
      fr: 'Modifier le label',
    },
    addLabel: {
      en: 'Add voice example',
      fr: 'Ajouter un exemple de contenu',
    },
    editDescription: {
      en: 'Define the voice example label to help AI decide when to use it.',
      fr: "Définissez le label de l'exemple de contenu pour aider l'IA à décider quand l'utiliser.",
    },
    selectAType: {
      en: 'Select a type',
      fr: 'Sélectionner un type',
    },
    website: {
      en: 'Website',
      fr: 'Site web',
    },
    socialMedia: {
      en: 'Social media',
      fr: 'Réseaux sociaux',
    },
    email: {
      en: 'Email',
      fr: 'Email',
    },
    advertising: {
      en: 'Advertising',
      fr: 'Publicité',
    },
    other: {
      en: 'Other',
      fr: 'Autre',
    },
    homepage: {
      en: 'Homepage',
      fr: "Page d'accueil",
    },
    productPage: {
      en: 'Product page',
      fr: 'Page de produit',
    },
    blogPost: {
      en: 'Blog post',
      fr: 'Article de blog',
    },
    landingPage: {
      en: 'Landing page',
      fr: 'Page de destination',
    },
    aboutUsPage: {
      en: 'About us page',
      fr: 'Page à propos',
    },
    collectionPage: {
      en: 'Collection page',
      fr: 'Page de collection',
    },
    caseStudy: {
      en: 'Case study',
      fr: 'Étude de cas',
    },
    linkedin: {
      en: 'Linkedin',
      fr: 'Linkedin',
    },
    twitter: {
      en: 'Twitter',
      fr: 'Twitter',
    },
    facebook: {
      en: 'Facebook',
      fr: 'Facebook',
    },
    pinterest: {
      en: 'Pinterest',
      fr: 'Pinterest',
    },
    instagram: {
      en: 'Instagram',
      fr: 'Instagram',
    },
    reddit: {
      en: 'Reddit',
      fr: 'Reddit',
    },
    newsletter: {
      en: 'Newsletter',
      fr: 'Newsletter',
    },
    coldOutreach: {
      en: 'Cold outreach',
      fr: 'Cold outreach',
    },
    productUpdate: {
      en: 'Product update',
      fr: 'Mise à jour de produit',
    },
    searchAds: {
      en: 'Search ads',
      fr: 'Publicités de recherche',
    },
    socialMediaAds: {
      en: 'Social media ads',
      fr: 'Publicités de réseaux sociaux',
    },
    printAds: {
      en: 'Print ads',
      fr: 'Publicités imprimées',
    },
    delete: {
      en: 'Delete voice example',
      fr: "Supprimer l'exemple",
    },
    selectType: {
      en: 'Select a type',
      fr: 'Sélectionner un type',
    },
  },
  'app.brand-context.-tab-keyword-blacklisted': {
    keywordBlacklisted: {
      en: 'Keyword blacklisted',
      fr: 'Termes à exclure',
    },
  },

  'app.brand-context.-tab-content': {
    blogPosts: {
      en: 'Content',
      fr: 'Contenu',
    },
    mainContent: {
      en: 'Main content',
      fr: 'Contenu principal',
    },
    voice: {
      en: 'Voice',
      fr: 'Voix',
    },
    selectVoice: {
      en: 'Select a voice',
      fr: 'Sélectionner une voix',
    },
    brandInContent: {
      en: 'Mention the brand in content',
      fr: 'Inclure votre marque dans le contenu',
    },
    inclusiveLanguage: {
      en: 'Inclusive language',
      fr: 'Langage inclusif',
    },
    product: {
      en: 'Product',
      fr: 'Produit',
    },
    collection: {
      en: 'Collection',
      fr: 'Collection',
    },
    firstPersonSingularTitle: {
      en: 'First person singular',
      fr: 'Première personne du singulier',
    },
    firstPersonSingularDescription: {
      en: '(I, me, my, mine)',
      fr: '(je, moi, mon, ma)',
    },
    firstPersonPluralTitle: {
      en: 'First person plural',
      fr: 'Première personne du pluriel',
    },
    firstPersonPluralDescription: {
      en: '(we, us, our, ours)',
      fr: '(nous, nous, notre, notre)',
    },
    secondPersonTitle: {
      en: 'Second person',
      fr: 'Deuxième personne',
    },
    secondPersonDescription: {
      en: '(you, your, yours)',
      fr: '(vous, votre, votre)',
    },
    thirdPersonTitle: {
      en: 'Third person',
      fr: 'Troisième personne',
    },
    thirdPersonDescription: {
      en: '(he, she, it, their)',
      fr: '(il, elle, cela, leur)',
    },
    tonesOfVoice: {
      en: 'Tones of voice',
      fr: 'Tons',
    },
    hasEmoji: {
      en: 'Add emojis',
      fr: 'Ajouter des émojis',
    },
  },
  'app._app.brand-context.-section-values-tag': {
    formal: {
      en: 'Formal',
      fr: 'Formel',
    },
    casual: {
      en: 'Casual',
      fr: 'Casual',
    },
    confident: {
      en: 'Confident',
      fr: 'Confiant',
    },
    humorous: {
      en: 'Humorous',
      fr: 'Humoristique',
    },
    persuasive: {
      en: 'Persuasive',
      fr: 'Persuasif',
    },
    empathetic: {
      en: 'Empathetic',
      fr: 'Empathique',
    },
    inquisitive: {
      en: 'Inquisitive',
      fr: 'Curieux',
    },
  },

  'app.brand-context.brand-filler': {
    generate: {
      en: 'Generate',
      fr: 'Générer',
    },
    addUrls: {
      en: 'Add URLs',
      fr: 'Ajouter des liens',
    },
    discard: {
      en: 'Discard',
      fr: 'Rejeter',
    },
    save: {
      en: 'Save',
      fr: 'Enregistrer',
    },
    autoFillBrandContextWithUrlsLinks: {
      en: 'Auto fill Brand context with URLs links',
      fr: 'Auto-remplir le contexte de la marque avec les liens web',
    },
    saveTimeByLettingAiAnalyzeYourBrandContextFromWebLinks: {
      en: 'Save time by letting AI analyze your brand context from web links',
      fr: "Gagnez du temps en laissant l'IA analyser votre contexte de marque<br/>à partir des liens web",
    },
    reviewAiGeneratedBrandContext: {
      en: 'Review AI-generated brand context',
      fr: 'Review AI-generated brand context',
    },
    makeSureToReviewAllSections: {
      en: 'Make sure to review all sections, including the other tabs, before saving.\n You can edit these details anytime.',
      fr: "Veuillez vérifier toutes les sections, y compris les autres onglets, avant d'enregistrer.\n Vous pouvez modifier ces détails à tout moment.",
    },
    regenerateBrandContextWithUrlLinks: {
      en: 'Regenerate Brand Context with URL links?',
      fr: 'Régénérer le contexte de la marque avec les liens web ?',
    },
    autoFillBrandContext: {
      en: 'Auto fill Brand context',
      fr: 'Auto-remplir le contexte de la marque',
    },
    generatingBrandContext: {
      en: 'Generating brand context',
      fr: 'Génération du contexte de la marque',
    },
    thisMayTakeLessThanAMinute: {
      en: `This may take <span class="font-bold text-black">less than a minute</span>`,
      fr: `Cela devrait prendre <span class="font-bold text-black">moins d'une minute</span>`,
    },
    cancelAiGeneration: {
      en: 'Cancel AI generation',
      fr: 'Annuler la génération',
    },
    cancelAiGenerationDescription: {
      en: 'Closing this will stop the process and discard any content already generated.',
      fr: 'Fermer cette fenêtre arrêtera le processus et supprimera tout contenu déjà généré.',
    },
    cancelGeneration: {
      en: 'Cancel generation',
      fr: 'Annuler la génération',
    },
    keepGenerating: {
      en: 'Keep generating',
      fr: 'Continuer à générer',
    },
    somethingWentWrong: {
      en: 'Something went wrong',
      fr: 'Une erreur est survenue',
    },
    thereWasAProblemGeneratingYourBrandContext: {
      en: 'There was a problem generating your brand context. You can try again or return to the previous step to review your URLs.',
      fr: "Il y a eu un problème lors de la génération du contexte de la marque. Vous pouvez réessayer ou retourner à l'étape précédente pour revoir vos liens web.",
    },
    addYourUrlsAndAiWillGenerateYourBrandDetailsForYouToReview: {
      en: 'Add your URLs and AI will generate your brand details for you to review.',
      fr: "Ajoutez vos liens web et l'IA générera les détails de votre marque pour que vous puissiez les revoir.",
    },
    homepage: {
      en: 'Homepage',
      fr: "Page d'accueil",
    },
    aboutUs: {
      en: 'About us',
      fr: 'À propos',
    },
    optional: {
      en: '(optional)',
      fr: '(optionnel)',
    },
    blogsPosts: {
      en: 'Content {{count}}',
      fr: 'Contenu {{count}}',
    },
    exempleUrl: {
      en: 'https://example.com',
      fr: 'https://exemple.com',
    },
    addBlogUrl: {
      en: 'Add another content URL',
      fr: 'Ajouter un autre lien de contenu',
    },
    targeting: {
      en: 'Targeting',
      fr: 'Ciblage',
    },
    targetingDescription: {
      en: 'Selecting a default country and language helps AI find the main version of your website if it exists in different languages',
      fr: "Sélectionner un pays et une langue par défaut aide l'IA à trouver la version principale de votre site web si elle existe dans différentes langues",
    },
    analyseUrlsAndReview: {
      en: 'Analyze URLs & Review',
      fr: 'Analyser et réviser',
    },
    brandContextGenerated: {
      en: 'Brand context generated',
      fr: 'Contexte de la marque généré',
    },
    yourBrandContextHasBeenSuccessfullyGenerated: {
      en: 'Your brand context has been successfully generated',
      fr: 'Votre contexte de marque a été généré avec succès',
    },
  },
  'app.brand-context.discard-modal': {
    title: {
      en: 'Discard changes',
      fr: 'Rejeter les modifications',
    },
    description: {
      en: 'You can still save these details and keep improving or regenerating them later.',
      fr: 'Vous pouvez toujours enregistrer ces détails et les améliorer ou les régénérer plus tard.',
    },
    discard: {
      en: 'Discard changes',
      fr: 'Rejeter les modifications',
    },
    keepReviewing: {
      en: 'Keep reviewing',
      fr: 'Continuer à relire',
    },
  },
};
